// extracted by mini-css-extract-plugin
export default {"variables":"\"../variables.module.css\"","font-primary":"Lato, Arial, sans-serif","font-size-middle":"16px","main":"AllOffices_main__DVwUL","wrapper":"AllOffices_wrapper__kodS0"};